import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import DropFileUploader from '../../components/form/DropFileUploader';
import FormField from '../../components/form/FormField';
import ReduxFormPackSelect from '../../components/reduxFormMUIWrapper/ReduxFormPackSelect';

const useStyles = makeStyles({
  root: {
    composes: 'flexColumn stretch',
  },
});

let OverlayForm = (props) => {
  const { handleSubmit } = props;
  const classes = useStyles(props);

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      <FormField label="Pack" name="pack" component={ReduxFormPackSelect} fullWidth />
      <FormField label="Nom" name="name" fullWidth />
      <FormField label="Description" name="description" fullWidth />
      <FormField label="Image" name="image" component={DropFileUploader} fullWidth />
      <input type="submit" />
    </form>
  );
};

OverlayForm.propTypes = {
  onSubmit: PropTypes.func,
};

OverlayForm = reduxForm({
  form: 'overlayForm',
  enableReinitialize: true,
})(OverlayForm);

// Edition: the overlay loaded by editOverlay. Creation: the `initialValues` prop (the pack preselected).
OverlayForm = connect((state, ownProps) => {
  if (ownProps.initialValues) return {};
  const { pack, name, description, image } = state.overlays?.overlay || {};
  return {
    initialValues: { pack: pack?.objectId ?? '', name, description, image },
  };
})(OverlayForm);

export default OverlayForm;
